import { Box, Grid } from '@factorialco/deprecated-design-system'
import { BenefitsBenefitAvailabilityFragment } from 'generated/resources/graphql'

import {
  BenefitsCardBenefit,
  BenefitsCardBenefitSkeleton,
} from 'modules/benefits/components/BenefitsCardBenefit'
import { useActiveMarkets } from 'modules/benefits/hooks/useActiveMarkets'
import { getBenefitsList } from 'modules/benefits/lib/benefitListings'

interface Props {
  showStatus?: boolean
  featureAvailabilities?: BenefitsBenefitAvailabilityFragment[]
}

const BenefitsCardBenefitList = ({ showStatus = false, featureAvailabilities }: Props) => {
  const activeMarkets = useActiveMarkets()?.activeMarkets

  const benefits = activeMarkets?.flatMap((market) => {
    return getBenefitsList(market, featureAvailabilities)
  })

  const renderedBenefits = benefits ?? new Array(3).fill(null)

  return (
    <Box gap="s12" flexDirection="row" flexWrap="wrap">
      <Grid variant="fixed">
        {renderedBenefits.map((benefit, idx) => (
          <Box key={idx} gridColSpan={{ xxs: 12, xs: 12, s: 12, m: 4, l: 4, xl: 3, xxl: 3 }}>
            {benefit ? (
              <BenefitsCardBenefit
                key={benefit.title}
                benefitListing={benefit}
                showTag={showStatus}
              />
            ) : (
              <BenefitsCardBenefitSkeleton />
            )}
          </Box>
        ))}
      </Grid>
    </Box>
  )
}

export { BenefitsCardBenefitList }
